// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA0rkvWgXtKkpfrlLXXMqxCmUnbUHYl2Bc",
  authDomain: "nike-92728.firebaseapp.com",
  projectId: "nike-92728",
  storageBucket: "nike-92728.firebasestorage.app",
  messagingSenderId: "651122373186",
  appId: "1:651122373186:web:e218a3aa4e2494b0abf3db",
  measurementId: "G-0D2X3J2M13"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Analytics
export const analytics = getAnalytics(app);

export default app;
